// import dependencies ===>
import React from "react";
// import assets and scss files ===>
import "./printRxTemplateHeaderView.scss";
import close from "../../../assets/close.svg";
import downloadIcon from "../../../assets/DownloadIconGrey.svg";
import printIcon from "../../../assets/print_icon.svg";

const PrintRxTemplateHeaderView = (props) => {
  const { printPDF, downloadFile, handleClose } = props;

  return (
    <div className="print-rx-template-header-container">
      <div className="prthc-header-print" onClick={printPDF}>
        <img src={printIcon} alt="" />
      </div>
      <div className="prthc-header-download" onClick={downloadFile}>
        <img src={downloadIcon} alt="" />
      </div>
      <div className="prthc-header-close" onClick={handleClose}>
        <img src={close} alt="" />
      </div>
    </div>
  );
};

export default PrintRxTemplateHeaderView;
